import * as React from 'react';
import {
  StackLayout,
  HeadingText,
  Box,
  VisuallyHidden,
  InputStatusMessage,
} from '@leagueplatform/genesis-core';
import { EntityFormBanner, HintText } from '@web-config-app/core-react-ui';
import { EntityFormArrayControlProps } from '../../types/controls';

export const ArrayPrimitiveGroup: React.FC<
  React.PropsWithChildren<Partial<EntityFormArrayControlProps>>
> = ({
  hint,
  label,
  banner,
  children,
  hideLabel,
  statusMessage,
  inputStatus,
}) => {
  const showBanner = banner?.title || banner?.description;

  const LabelHeading = (
    <HeadingText
      size="sm"
      as="legend"
      level="display"
      emphasis="subtle"
      css={{ typography: '$label' }}
    >
      {label}
    </HeadingText>
  );

  return (
    <StackLayout
      spacing="$half"
      data-testid="array-primitive-group"
      css={{ width: '100%' }}
    >
      {showBanner && (
        <EntityFormBanner
          status={banner.status}
          title={banner.title}
          description={banner.description}
          css={{ marginBlockEnd: '$half' }}
        />
      )}
      <Box
        as="fieldset"
        css={{ width: '100%', border: '$none', padding: '$none' }}
      >
        {hideLabel ? (
          <VisuallyHidden>{LabelHeading}</VisuallyHidden>
        ) : (
          LabelHeading
        )}

        {hint && (
          <HintText css={{ paddingBlockStart: '$quarter' }}>{hint}</HintText>
        )}
        {inputStatus && (
          <InputStatusMessage inputStatus={inputStatus} id="statusComponent">
            {statusMessage}
          </InputStatusMessage>
        )}
        <StackLayout
          css={{ listStyleType: 'none', paddingInlineStart: '$none' }}
        >
          {children}
        </StackLayout>
      </Box>
    </StackLayout>
  );
};
